import { connect } from 'react-redux';
import Component from './Component';

import onClickActionMenuItem from './Handlers/onClickActionMenuItem';
import onUpload from './Handlers/onUpload';
import onChangeNotes from './Handlers/onChangeNotes';
import onChangeEstimateField from './Handlers/onChangeEstimateField';
import fetchEstimate from '../../Services/fetchEstimate';
import reviseEstimate from '../../Services/reviseEstimate';

const mapStateToProps = (state) => ({
  estimate: state.screens.EstimateView.estimate,
  estimateStatuses: state.core.estimateStatuses,
  estimateTenderStatuses: state.core.estimateTenderStatuses,
  estimateLatestActions: state.core.estimateLatestActions,
})

const actionCreators = {
  onClickActionMenuItem,
  onUpload,
  onChangeNotes,
  onChangeEstimateField,
  fetchEstimate,
  reviseEstimate
};

export default connect(mapStateToProps, actionCreators)(Component);
